import * as React from 'react';

function SvgControlRadioOn(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 24a9 9 0 110-18 9 9 0 010 18zm0-1.084a7.916 7.916 0 100-15.832 7.916 7.916 0 000 15.832zM10 15a5 5 0 1010 0 5 5 0 00-10 0z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgControlRadioOn;
